import React from 'react'
import { Icon, Button } from '../..'
import {
  PagesContainer,
  PageButton,
  Container,
  ContainerAnimation,
  PageButtonContainer,
} from './styles'

export type Props = {
  children?: any
  currentPage: number
  pagesTotal: number
  onPageChange: Function
  animation?: boolean
  style?: object
}

const PaginationTableAlt: React.FC<Props> = (props: Props): JSX.Element => {
  const isFirstPage = props.currentPage === 1
  const isLastPage = props.currentPage === props.pagesTotal

  function generatePageButton(value: number): JSX.Element {
    return (
      <PageButton
        data-qa={`button-${value}`}
        className={value === props.currentPage ? '' : 'inactive'}
        onClick={() => props.onPageChange(value)}
      >
        {value}
      </PageButton>
    )
  }

  function generateDots(): JSX.Element {
    return (
      <PageButton data-qa="span-dots" className="inactive dots">
        ...
      </PageButton>
    )
  }

  function getButtons(pagesTotal: number): Array<any> {
    let buttons = []
    const maxPagesDisplayed: number = 8
    if (pagesTotal < maxPagesDisplayed) {
      for (let value = 1; value <= pagesTotal; value++) {
        buttons.push(generatePageButton(value))
      }
      return buttons
    }
    const pagesAfterBreak: number = 2
    const pagesOnLastGroup: number = 5
    const minStartBlock: number = 3
    const pagesPerStep = 1
    const maxFirstblockAmount = 3 //
    const current: number = props.currentPage
    const penultimate: number = pagesTotal - pagesAfterBreak
    const isFinalPages: boolean = current < penultimate
    const lastGroup: number = pagesTotal - pagesOnLastGroup
    const start: number =
      current <= minStartBlock
        ? pagesPerStep
        : isFinalPages
        ? current - pagesAfterBreak
        : lastGroup
    const end: number =
      current <= minStartBlock
        ? maxFirstblockAmount
        : isFinalPages
        ? current + pagesPerStep
        : penultimate
    for (let value = start; value <= end; value++) {
      buttons.push(generatePageButton(value))
    }
    if (start < lastGroup) {
      buttons.push(generateDots())
      buttons.push(generatePageButton(pagesTotal - pagesAfterBreak))
    }
    buttons.push(generatePageButton(pagesTotal - pagesPerStep))
    buttons.push(generatePageButton(pagesTotal))

    return buttons
  }

  return (
    <Container>
      {props.animation && <ContainerAnimation />}
      <PagesContainer style={props.style}>
        <Button
          onClick={
            isFirstPage ? null : () => props.onPageChange(props.currentPage - 1)
          }
          disabled={isFirstPage}
          theme="secondary"
        >
          <Icon name="arrow_back" data-qa="icon-arrow-left" />
          Anterior
        </Button>

        <div style={{ display: 'flex' }}>
          {getButtons(props.pagesTotal).map((button, key) => (
            <PageButtonContainer key={key}>{button}</PageButtonContainer>
          ))}
        </div>

        <Button
          onClick={
            isLastPage ? null : () => props.onPageChange(props.currentPage + 1)
          }
          disabled={isLastPage}
          theme="secondary"
        >
          Próxima
          <Icon name="arrow" data-qa="icon-arrow-right" />
        </Button>
      </PagesContainer>
    </Container>
  )
}

export default PaginationTableAlt
